import { Note, Cross } from '@creditornot/cb-icons';
import { cbSemanticCssVars, colors } from '@creditornot/cb-ingredients';
import { Spinner } from '@creditornot/cb-progress';
import { cssThemedValue } from '@creditornot/cb-sc-utils';
import React from 'react';
import styled from 'styled-components';

import { getPrettyFileSize, trimStringInTheMiddle } from 'modules/onboarding-page/utils';

type Props = {
  name: string;
  sizeInBytes: number;
  onDelete?: () => void;
  isDeleting?: boolean;
};
const StyledNote = styled(Note)`
  height: 16px;
  margin-inline-end: 8px;
  fill: ${cssThemedValue({ light: colors.pepper24, dark: colors.salt24 })};
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  padding-block: 12px;
  padding-inline: 8px;
  border-radius: 8px;
  border: 1px solid ${cbSemanticCssVars.borderPrimary};
  margin-block-start: 10px;
  min-height: 48px;
`;

const FileInfo = styled.div`
  margin-inline-end: 8px;
`;

const StyledCross = styled(Cross)`
  height: 10px;
  margin-inline-start: auto;
  margin-block: 6px;
  margin-inline-end: 6px;
  fill: ${cssThemedValue({ light: colors.pepper24, dark: colors.salt100 })};
`;

const StyledSpinner = styled(Spinner)`
  margin-inline-start: auto;

  margin-inline-end: 6px;
`;

const UploadedFile = ({ name, sizeInBytes, onDelete, isDeleting }: Props) => {
  return (
    <Wrapper data-test-id={name}>
      <StyledNote />

      <FileInfo>
        {trimStringInTheMiddle(name)} ({getPrettyFileSize(sizeInBytes)})
      </FileInfo>

      {isDeleting ? (
        <StyledSpinner data-test-id="delete-spinner" size="small" />
      ) : (
        onDelete && <StyledCross data-test-id="delete-cross" onClick={onDelete} />
      )}
    </Wrapper>
  );
};

export default UploadedFile;
